// extracted by mini-css-extract-plugin
export default {"wrapper":"fww7krVwvfbUaTSzjscn","collapseContainer":"tbQ2Josz88S634Nql_S_","title":"oocKtA9HBZ9emaOmTTMA","icon":"jiPTM__UwK3YXnz0fXa6"};